// const BASE_URL_AUTH = "http://192.168.1.19:82/api/"; //----->local sign url
// const BASE_URL_GST = "http://192.168.0.219:83/api/"; //----->local gst url
// const BASE_URL_CIN = "http://192.168.0.219:84/api/"; //----->local mobile360 url
// const BASE_URL_MOBILE360 = "http://192.168.1.19:86/api/"; //----->local mobile360 url
// const BASE_URL_MSME = "http://192.168.1.19:91/api/"; //----->local msme url
// const BASE_URL_MAD = "http://192.168.0.219:96/"; //----->local msme url

// const BASE_URL_E_COMMERCE = "http://192.168.1.19:8000/"; //----->local e-commerce url
// const BASE_URL_E_PINCODE = "http://192.168.1.19:90/"; //----->local e-commerce url
const MAPS_APIKEY = "AIzaSyD1i6kYRiEeowcGm-6z5Fsw3ZHtmiGYL3Y";

// const BASE_URL_AUTH = "http://110.226.126.241:82/api/"
// const BASE_URL_GST = "http://110.226.126.241:83/api/"
// const BASE_URL_CIN = "http://110.226.126.241:84/api/"
// const BASE_URL_MOBILE360 = "http://110.226.126.241:86/api/"
// const BASE_URL_MSME = "http://110.226.126.241:91/api/"

// const BASE_URL_ALL = "http://110.226.126.241:92/" // <<----------- public ip
// const BASE_URL_ALL = "http://192.168.0.219:92/" // <<----------- local ip
// const BASE_URL_ALL = "http://192.168.0.219:92/" // <<----------- local ip
const BASE_URL_ALL = "https://api.fact-byte.com/"; // <<----------- local ip
// const BASE_URL_ALL = "https://demoapi.fact-byte.com/"; // <<----------- local ip

// const BASE_URL_LOGIN = "http://192.168.1.19:92/" // <<----------- local ip
// const BASE_URL_LOGIN = "http://192.168.1.10:8936/" // <<----------- Nayan ip
// const BASE_URL_LOGIN = "http://192.168.1.18:1818/" //<-------- local ip
// const BASE_URL_LOGIN = "http://192.168.1.22:8000/" //<-------- live ip
// const BASE_URL_LOGIN = "https://fact-byte.com/"; //<-------- live ip
// const BASE_URL_LOGIN = "https://3ad95ff783fc.ngrok-free.app"; //<-------- live ip
const BASE_URL_LOGIN = "https://facterp.fact-byte.com"; //<-------- live ip
// const BASE_URL_LOGIN = "https://thd7638q-8018.inc1.devtunnels.ms/"; //<-------- live ip
// const BASE_URL_LOGIN = "http://192.168.137.67:8018/"; //<-------- live ip
// const BASE_URL_LOGIN = "http://209.182.233.31:8069"; //<-------- live ip
// const BASE_URL_LOGIN = "http://172.168.1.31:8018/"; //<-------- live ip
// const BASE_URL_LOGIN = "http://172.168.1.66:8018/"; //<-------- Harry ip
const MAPS_API = "AIzaSyD1i6kYRiEeowcGm-6z5Fsw3ZHtmiGYL3YA";

// const BASE_URL_PROFILE = "http://192.168.1.18:1818"; //<-------- Upadated user url

const CONFIG = {
  // BASE_URL_AUTH,
  // BASE_URL_GST,
  // BASE_URL_PROFILE,
  // BASE_URL_MOBILE360,
  // BASE_URL_CIN,
  // BASE_URL_MSME, 
  // BASE_URL_E_COMMERCE,
  BASE_URL_ALL,
  BASE_URL_LOGIN,
  // BASE_URL_E_PINCODE,
  MAPS_APIKEY,
  // BASE_URL_MAD,
  MAPS_API
};

export default CONFIG;
